export function getProfileType(isPublic) {
    return isPublic ? 'public' : 'private';
}
// These functions have been copy/pasted from `apps/rango/utils/Errors.ts` to avoid creating a third package to share these logic.
export function throwIfAborted(signal) {
    if (signal.aborted) {
        throw new Error('Operation canceled');
    }
}
export function getErrorMessage(error) {
    return error instanceof Error ? error.message : 'Something went wrong. Please try again.';
}
export function loadState(key) {
    // For avoiding run in SSR
    if (typeof window === 'undefined') {
        return;
    }
    try {
        const serializedState = localStorage.getItem(key);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    }
    catch (err) {
        console.error('Could not load state', err);
        return undefined;
    }
}
export function saveState(key, state) {
    // For avoiding run in SSR
    if (typeof window === 'undefined') {
        return;
    }
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem(key, serializedState);
    }
    catch (err) {
        console.error('Could not save state', err);
    }
}
